import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDBWalGainBI6ICfsYTXf2Y7BhAPDpGvqk",
  authDomain: "intellitutor-481211.firebaseapp.com",
  projectId: "intellitutor-481211",
  storageBucket: "intellitutor-481211.firebasestorage.app",
  messagingSenderId: "188976723880",
  appId: "1:188976723880:web:46cb44665515e3031d0f9d"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);
